import React, { useState, useEffect, useCallback } from 'react'

// Deps
import { redirect } from 'controllers/navigator'
import QRCode from 'qrcode'

// Partials
import Btn from 'views/shared/partials/btn'
import Link from 'views/shared/partials/link'
import Loader from 'views/shared/partials/loader'
import Image from 'views/shared/partials/image'
import Pricebox from 'views/shared/partials/pricebox'
// import ConversionInfo from 'views/shared/partials/conversion-info'
import OrderStatus from 'views/shared/partials/order-status'

// Utils
import { openModal } from 'utils/modals'

// Functions
import formatDate from 'functions/format-date'
// import getCurrencySymbol from 'functions/get-currency-symbol'

// Sections
import Breadcrumbs from 'views/admin/sections/breadcrumbs'

// Services
import orderServices from 'services/order'

const getPeriodTime = (type) => {
	switch(type) {
		case "day":
			return 'Günde';
		case "week":
			return 'Haftada';
		case "month":
			return 'Ayda';
		case "year":
			return 'Yılda';
		default:
			return 'None';
	}
}

const OrderTemplateDetail = (props) => {
	const templateID = props.match.params.id;

	const [data, setData] = useState(false);

	const getData = useCallback(() => {
		setData(false);
		orderServices.getOrderTemplate(templateID).then((payload) => {
			let qrImage = false;
			let qrUrl = window.location.origin + '/pay/barcode/' + payload.token;
			QRCode.toDataURL(qrUrl, {
				margin: 0,
				color: {
					dark: '#3e475f',
					light: '#FFF'
				}
			}).then(image => {
				qrImage = image;
			}).catch(err => {
				console.error(err)
			}).finally(() => {
				setData({ ...payload, qrImage: qrImage, qrUrl: qrUrl });
			})
		});
	}, [templateID]);

	const deleteOrderTemplate = () => {
		openModal(
			'confirm',
			{
				message: 'Ödeme şablonunu iptal etmek istediğinizden emin misiniz?',
				onConfirm: () => {
					orderServices.deleteOrderTemplate(data.id).then(() => {
						redirect('orderPlans');
					}).catch(() => {})
				}
			}
		)
	}

	useEffect(() => {
		getData();
	}, [templateID, getData])

	return (
		<main className="page order-template-detail">
			<Breadcrumbs
				midSections={[
					{href: 'orderTemplates'}
				]} />
			<section className="portlet section detail-info loader-container">
				<Loader loading={!data} />
				{data &&
					<React.Fragment>
						<div className="portlet-header">
							<h1 className="portlet-title">
								<span>{(data.client.invoice_type === 2 && data.client.company_name) ? data.client.company_name : (data.client.executive_name + ' ' + data.client.executive_surname)}</span>
								{(data.client.invoice_type === 2 && data.client.company_name) &&
									<span className="title-subtitle">{data.client.executive_name} {data.client.executive_surname}</span>
								}
								<span className="label category-template">Ödeme Şablonları</span>
							</h1>

							<div className="header-controls">
								<Btn
									white small wide
									onClick={() => { openModal('update-order', { template: true, orderCode: data.id, onSuccess: getData }); }}
									icon="edit">
									Bilgileri Düzenle
								</Btn>
								<Btn
									small wide error outline
									onClick={deleteOrderTemplate}
									icon="trash">
									İptal Et
								</Btn>
							</div>
						</div>
						<div className="portlet-section bottom">
							<div className="portlet-infobar horizontal">
								<div className="grid-container">
									<div className="row">
										<div className="col x8">
											<strong className="infobar-title">Ödeme Bilgileri</strong>
											<div className="row">
												<div className="col x6">
													<div className="infobar-section">
														<strong className="section-title">Period Sayısı:</strong>
														<span className="section-data">
															<p>
																<span className="label">{data.period_count} Toplam </span>
																<span className="label light">
																	{data.period_time_range ?
																		<React.Fragment>
																			{data.period_time_range} {getPeriodTime(data.period_time)}} bir
																		</React.Fragment>
																		:
																		'Başlangıç tarihi'
																	}
																</span>
															</p>
														</span>
													</div>

													<div className="infobar-section">
														<strong className="section-title">İşletme Grubu</strong>
														<span className="section-data">
															{data.group.name}
														</span>
													</div>

													<div className="infobar-section">
														<strong className="section-title">Ödeme Oluşturan</strong>
														<span className="section-data">
															{data.account.name} {data.account.surname}
														</span>
													</div>
												</div>
												<div className="col x6">
													<div className="infobar-section">
														<strong className="section-title">Sipariş Tutarı</strong>
														<span className="section-data">
															<Pricebox
																showCode monochrome
																price={data.total_amount}
																currency={data.price_type.currency_symbol} />
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Sipariş Durumu</strong>
														<span className="section-data">
															<OrderStatus label status={data.status} />
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Oluşturulma Tarihi</strong>
														<span className="section-data">
															{formatDate(data.created_at)}
														</span>
													</div>
												</div>
											</div>

											<strong className="infobar-title">Ödeme Açıklaması</strong>
											<div className="row">
												<div className="col">
													<div className="infobar-section">
														<div className="section-data">
															{data.description}
														</div>
													</div>
												</div>
											</div>

											<strong className="infobar-title">Müşteri Bilgileri</strong>
											<div className="row">
												<div className="col x6">
													<div className="infobar-section">
														<strong className="section-title">Müşteri Tipi</strong>
														<span className="section-data">
															{data.client.invoice_type === 1 ?
																<label className="label dark">
																	Bireysel
																</label>
																:
																<label className="label">
																	Kurumsal
																</label>
															}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">{data.client.invoice_type === 2 ? 'Yetkili' : 'Müşteri'} Adı Soyadı</strong>
														<span className="section-data">
															{data.client.executive_name} {data.client.executive_surname}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Müşteri Kodu #:</strong>
														<span className="section-data">
															{data.client.client_code}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">Cep Telefonu</strong>
														<span className="section-data">
															{data.client.phone_number}
														</span>
													</div>
													<div className="infobar-section">
														<strong className="section-title">E-Posta Adresi</strong>
														<span className="section-data">
															{data.client.email}
														</span>
													</div>
												</div>
												<div className="col x6">
													<div className="infobar-section">
														<strong className="section-title">Firma Kısa Adı</strong>
														<span className="section-data">
															<Link href="clientDetail" className="link" params={{id: data.client.client_code}}>{data.client.company_name ? data.client.company_name : '-'}</Link>
														</span>
													</div>
													{data.client.invoice_type === 2 ?
														<React.Fragment>
															<div className="infobar-section">
																<strong className="section-title">Vergi Numarası</strong>
																<span className="section-data">
																	{data.client.tax_number ? data.client.tax_number : '-'}
																</span>
															</div>
															<div className="infobar-section">
																<strong className="section-title">Vergi Dairesi</strong>
																<span className="section-data">
																	{data.client.tax_office ? data.client.tax_office : '-'}
																</span>
															</div>
															<div className="infobar-section">
																<strong className="section-title">Vergi Ünvanı</strong>
																<span className="section-data">
																	{data.client.invoice_name ? data.client.invoice_name : '-'}
																</span>
															</div>
														</React.Fragment>:
														<React.Fragment>
															<div className="infobar-section">
																<strong className="section-title">TC Kimlik No</strong>
																<span className="section-data">
																	{data.client.identity_number ? data.client.identity_number : '-'}
																</span>
															</div>
														</React.Fragment>
													}

													<div className="infobar-section">
														<strong className="section-title">Fatura Adresi</strong>
														<span className="section-data">
															{data.client.invoice_address ? data.client.invoice_address : '-'}
														</span>
													</div>

													<div className="infobar-section">
														<strong className="section-title">Serbest Ödeme Özelliği</strong>
														<span className="section-data">
															{data.client.custom_order ? 'Aktif' : 'Deaktif'}
														</span>
													</div>
												</div>
											</div>
										</div>
										{<div className="col x4">
											<div className="portlet detail-qr">
												<div className="portlet-header border-bottom">
													<strong className="portlet-title">Ödeme Barkodu</strong>
												</div>

												<div className="portlet-section">
													<Image src={data.qrImage} className="qr-image" />
												</div>

												<div className="portlet-controls block border-top">
													<Btn
														icon="payment"
														tag="a"
														href={data.qrUrl}
														target="_blank"
														rel="_noopener"
														blue
														small>
														Ödeme Oluştur
													</Btn>
													<Btn
														icon="download"
														tag="a"
														download={'odeme-sablon-'+data.id+'.png'}
														href={data.qrImage} 
														green
														small>
														İndir
													</Btn>
													<Btn
														onClick={() => { window.print() }}
														icon="print"
														small>
														Yazdır
													</Btn>
												</div>
											</div>
										</div>}
									</div>
								</div>
							</div>
						</div>
						<div className="printarea detail-qr-print">
							<div className="print-container">
								<div className="print-info">
									<strong>Ödeme Açıklaması</strong>
									<p>{data.description}</p>
								</div>
								<div className="print-info print-price">
									<Pricebox
										showCode monochrome
										price={data.total_amount}
										currency={data.price_type.currency_symbol} />
								</div>
								<img src={data.qrImage} alt={data.qrUrl} className="print-image" />
								<div className="print-url">{data.qrUrl}</div>
							</div>
						</div>
					</React.Fragment>
				}
			</section>
		</main>
	)
}

export default OrderTemplateDetail